import React, { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LeftSidebarMenu from "./components/Layout/LeftSidebarMenu";
import Footer from "./components/Layout/Footer";
import TopNavbar from "./components/Layout/TopNavbar";
import ScrollToTop from "./components/Layout/ScrollToTop";

import Dashboard from "./pages/client-dashboard/dashboard";
import Invoices from "./pages/client-dashboard/invoices";
import Analytics from "./pages/client-dashboard/analytics";
import Orders from "./pages/client-dashboard/orders";
import ChatTranscripts from "./pages/client-dashboard/chat-transcripts";
import StoreManagement from "./pages/client-dashboard/store-management";
import POS_Sync from "./pages/client-dashboard/pos-sync";
import DocumentManagement from "./pages/client-dashboard/document-management";
import Notifications from "./pages/client-dashboard/notifications";
import UserManagement from "./pages/client-dashboard/user-management";
import CreateStore from "./pages/client-dashboard/store-management/create-store";
import EditStore from "./pages/client-dashboard/store-management/edit-store";
import Pricing from "./pages/client-dashboard/store-management/pricing";
import ChatBotSnippet from "./pages/client-dashboard/store-management/chatbot-snippet";
import ConfigurePOS from "./pages/client-dashboard/pos-sync/configure";
import AddingNewUser from "./pages/client-dashboard/user-management/add-user";
import EditUserPage from "./pages/client-dashboard/user-management/edit-user";
import ChatWindow from "./pages/client-dashboard/chat-transcripts/chat-window";
import DocDetails from "./pages/client-dashboard/document-management/documents";
import AddDoc from "./pages/client-dashboard/document-management/add-document";
import Products from "./pages/client-dashboard/products";
import EditProfile from "./components/Layout/TopNavbar/EditProfile";
import ProtectedRoute from "./authentication/ProtectedRoute";
import SubscriptionProtectedRoute from "./authentication/SubscriptionProtectedRoute";
import SignInForm from "./authentication/SignInForm";
import ForgotPasswordForm from "./authentication/ForgotPasswordForm";
import { AuthContext } from "./authentication/AuthContext";
import { useContext } from "react";
import FetchUpdatePOS from "./pages/client-dashboard/pos-sync/fetchupdate";
import ResetPasswordForm from "./authentication/ResetPassword";
import ProductsDetailsPage from "./pages/client-dashboard/products/product-details";
import ReportProblem from "./pages/client-dashboard/report-problem";
import SessionExpiryModal from "./authentication/SessionExpiry";
import SessionChatTranscript from "./components/ClientDashboard/ReportProblems/SessionChatTranscript";


const App = () => {
  const [active, setActive] = useState(false);
  const location = useLocation(); // ✅ better than window.location
  const toggleActive = () => setActive(!active);

  const isAuthPage = location.pathname.startsWith("/authentication");

  // ✅ Force light mode on app initialization (dark theme disabled)
  useEffect(() => {
    const htmlElement = document.querySelector("html");
    if (htmlElement) {
      htmlElement.classList.remove("dark-theme");
    }
    localStorage.setItem("theme", "light");
  }, []);

  return (
    <div className={`main-wrapper-content ${active ? "active" : ""}`}>
      {/* Top Navbar & Sidebar */}
      {!isAuthPage && (
        <>
          <TopNavbar toggleActive={toggleActive} />
          <LeftSidebarMenu toggleActive={toggleActive} />
        </>
      )}

      {/* Main content */}
      <div
        className="main-content"
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(100vh - 100px)",
        }}
      >
        <SessionExpiryModal />
        <ScrollToTop />

        <div style={{ flex: 1 }}>
          <Routes>
            {/* Authentication pages */}
            <Route path="/authentication/sign-in" element={<SignInForm />} />
            <Route path="/authentication/forgot-password/" element={<ForgotPasswordForm />} />
             <Route path="/authentication/reset-password/:token" element={<ResetPasswordForm />} />
              <Route path="/unauthorized" element={<h2>Not Allowed</h2>} />
               
            {/* Add other auth routes here */}

            {/* Protected Dashboard Pages */}
            <Route
              path="/"
              element={
                 <ProtectedRoute allowedRoles={["admin", "user"]}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

                {/* Orders */}
                <Route
                  path="/orders"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <Orders />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Chat Transcripts */}
                <Route
                  path="/chat-transcripts"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <ChatTranscripts />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/chat-transcripts/chats/:customer_id"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <ChatWindow />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Store Management */}
                <Route
                  path="/store-management"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <StoreManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/store-management/create-store"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <CreateStore />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/store-management/:store_id/edit-store"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <EditStore />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/store-management/pricing"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <Pricing />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/store-management/store/:store_id/chatbot-snippet"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <ChatBotSnippet />
                    </ProtectedRoute>
                  }
                />

                {/* POS Sync */}
                <Route
                  path="/pos-sync"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <POS_Sync />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/pos-sync/configure"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <ConfigurePOS />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/pos-sync/:store_id/fetch-update"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        < FetchUpdatePOS/>
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Document Management */}
                <Route
                  path="/document-management"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <DocumentManagement />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/document-management/documents/:store_id"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <DocDetails />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/document-management/documents/:store_id/add-document"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <AddDoc />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Invoices */}
                <Route
                  path="/invoices"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <Invoices />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Notifications */}
                <Route
                  path="/notifications"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <Notifications />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* User Management */}
                <Route
                  path="/user-management"
                  element={
                     <ProtectedRoute allowedRoles={["admin"]}>
                      <SubscriptionProtectedRoute>
                        <UserManagement />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/user-management/add-user"
                  element={
                     <ProtectedRoute allowedRoles={["admin"]}>
                      <SubscriptionProtectedRoute>
                        <AddingNewUser />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/user-management/:client_user_id/edit-user"
                  element={
                    <ProtectedRoute>
                      <SubscriptionProtectedRoute>
                        <EditUserPage />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile/edit"
                  element={
                    <ProtectedRoute>
                      <EditProfile />
                    </ProtectedRoute>
                  }
                />

                {/* Analytics */}
                <Route
                  path="/analytics"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <Analytics />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Products */}
                <Route
                  path="/products"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <Products />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                 {/* Products */}
                <Route
                  path="/products/product-details/:product_code"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <ProductsDetailsPage />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />
                 {/* Chat Problems Report */}
                <Route
                 path="/chat-problems-report"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <ReportProblem />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

                {/* Chat Reports - Session Transcript Detail */}
                <Route
                  path="/chat-reports/:feedback_id/transcript"
                  element={
                     <ProtectedRoute allowedRoles={["admin", "user"]}>
                      <SubscriptionProtectedRoute>
                        <SessionChatTranscript />
                      </SubscriptionProtectedRoute>
                    </ProtectedRoute>
                  }
                />

              </Routes>

             
               

            </div>

            {!isAuthPage && <Footer />}
          </div>
    </div>
  );
};

export default App;
